import React, { useContext } from "react";
import { useMap } from "@mapcomponents/react-maplibre";

import createPdf from "./lib/createPdf";
import { DataContext } from "../../context/DataContext";
import PrinterIcon from "@mui/icons-material/Print";
import { Button } from "@mui/material";

/**
 * Renders a button that will create a PDF version of the current map view (dimensions adjusted to fit Din A4 Paper).
 */
const MlCreatePdfButton = (props) => {
    const dataContext = useContext(DataContext);
    const mapHook = useMap({
        mapId: props.mapId,
        waitForLayer: props.insertBeforeLayer,
    });

    return (
        <>
            <Button
                variant="navtools"
                onClick={() => {
                    if (mapHook.map) {
                        const selectedFeature = dataContext.selectedFeatures[0];
                        const selectedFeatureMatches =
                            dataContext.selectedFeatureMatches;
                        const protectedAreas =
                            selectedFeatureMatches?.protectedAreas;
                        const pdfInformation = {};

                        if (selectedFeature) {
                            const properties = selectedFeature.properties;

                            Object.assign(pdfInformation, {
                                "FLIK-Nr.": properties.feldblockidentnummer,
                                Bodennutzungsart: properties.bodennutzungstyp,
                                Jahr: properties.jahr,
                                Fläche: dataContext.selectedArea,
                                Bundesland: properties.land,
                                Center: dataContext.selectedCenter
                                    ?.map((coordinate) => coordinate.toFixed(4))
                                    .join(", "),
                            });
                        }

                        Object.assign(pdfInformation, {
                            "Organische Böden":
                                selectedFeatureMatches?.matchingMoorArea,
                            "Schutzgebiet(e)":
                                Array.isArray(protectedAreas) &&
                                protectedAreas.length > 0
                                    ? `${protectedAreas.length} Schutzgebiet(e) überlagert`
                                    : "Keine Übereinstimung",
                            "NUT2 Gebiet(e)": selectedFeatureMatches?.NUT2,
                        });

                        createPdf(
                            mapHook.map,
                            null,
                            (loading) => {
                                dataContext.setLoading(loading);
                            },
                            pdfInformation,
                            selectedFeature,
                            undefined,
                        );
                    }
                }}
                sx={(theme) => ({
                    color: theme.palette.navigation.buttonColor,
                })}
            >
                <PrinterIcon />
            </Button>
        </>
    );
};

MlCreatePdfButton.defaultProps = {
    mapId: undefined,
};

export default MlCreatePdfButton;
